module.exports = __webpack_public_path__ + "static/media/cancelWhite.59ad8137.svg";